import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';
import { Button } from '@common/bw-ui/ui/button';

export interface BasketActionsProps {
  onAdd: () => void;
  onClear: () => void;
  className?: string;
}

export function BasketActions({
  onAdd,
  onClear,
  className,
  ...props
}: BasketActionsProps & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'tw:flex tw:flex-col tw:sm:flex-row tw:flex-wrap tw:gap-2 tw:pt-2 tw:pb-6',
        className,
      )}
      {...props}
    >
      <span
        data-slot="disclaimer"
        className="tw:order-first tw:md:order-last tw:w-full tw:md:w-auto tw:md:ml-auto tw:text-xs tw:md:text-sm tw:text-muted tw:text-right tw:self-center"
      >
        Prices exclude VAT
      </span>
      <Button
        data-slot="add-action"
        className="tw:w-full tw:sm:w-auto tw:sm:flex-none"
        onClick={onAdd}
      >
        Add another booking
      </Button>
      <Button
        data-slot="clear-action"
        variant="outline-primary"
        className="tw:w-full tw:sm:w-auto tw:border-border tw:text-muted tw:md:border-primary tw:md:text-primary"
        onClick={onClear}
      >
        Clear Basket
      </Button>
    </div>
  );
}
